import React from 'react';

const MessageAlerts = ({ inCompleteMessage, errorMessage }) => {
  if (!inCompleteMessage && !errorMessage) {
    return null;
  }

  return (
    <>
      {inCompleteMessage && (
        <div className="alert alert-danger fade in">
          <i className="fa fa-exclamation-circle"></i>
          &nbsp;
          <strong>
            <span dangerouslySetInnerHTML={{__html: inCompleteMessage}}></span>
          </strong>
        </div>
      )}

      {errorMessage && (
        <div className="alert alert-danger fade in">
          <i className="fa fa-exclamation-circle"></i>
          &nbsp;
          <strong>
            <span dangerouslySetInnerHTML={{__html: errorMessage}}></span>
          </strong>
        </div>
      )}
    </>
  );
};

export default MessageAlerts;